var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"console"},[_c('div',{staticClass:"topbar"},[_c('topbar')],1),_c('div',{staticClass:"sidebar"},[_c('sidebar')],1),_c('div',{staticClass:"content"},[_c('router-view')],1),_c('div',{staticClass:"footer"})])}
var staticRenderFns = []

export { render, staticRenderFns }